<template lang="html">
  <div class="quote-data clearfix">
    <div
      v-if="minimumMonthlyIncome"
      class="col-xs-12"
    >
      <hr>
      <h3 class="requerimentos">
        Requerimentos
      </h3>
      <div class="details-section">
        <ul>
          <li>
            Ser maior de 18 anos
          </li>
          <li>
            Renda mínima mensal de
            <strong>{{ minimumMonthlyIncome | currencyReals }}</strong>
          </li>
          <li>
            Conta bancária em um dos seguintes bancos:
            <strong>Bradesco, Caixa Econômica, Itaú, Santander</strong>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    minimumMonthlyIncome() {
      return this.$store.state.registration.minimumMonthlyIncome;
    },
  },
  beforeCreate() {
    this.$store.dispatch('registration/fetchMinimumMonthlyIncome');
  },
};
</script>
<style lang="scss" scoped>
  .quote-data {
    padding: 1rem;
  }

  li {
    color: #333333;
  }
</style>
